import styles from "./Popup.module.css";
import { Button, DialogContent, DialogTitle, FormControl, IconButton, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { useEffect } from "react";
import { authData } from "../GetAuth";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

const UpdateNotePopup = ({ setNoteModalOpen, noteData, selectBooking, setLoading, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;

    const { register, control, handleSubmit, formState: { errors }, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            delivery_note: "",
        },
    });

    useEffect(() => {
        setValue('delivery_note', noteData);
    }, [noteData, setValue]);

    const onSubmitLocal = (data) => {
        setNoteModalOpen(false);
        setLoading(true);

        axios.post(process.env.REACT_APP_API_URL + "v1/delivery/update-delivery-note/" + selectBooking.id, data, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                setLoading(false);
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType("success");

                setAllData(prev => {
                    return prev.map(i => {
                        if (i?.id === selectBooking.id)
                            return { ...i, delivery_note: data?.delivery_note }
                        return i;
                    })
                })
            } else {
                setLoading(false);
            }
        }).catch((error) => {
            setLoading(false);
        });
    }

    return (<>
        <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
            {noteData ? 'Update Delivery Note' : 'Add Delivery Note'}
            <IconButton onClick={(e) => setNoteModalOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
        </DialogTitle>
        <DialogContent className={`${styles.PopupContent}`}>
            <form onSubmit={handleSubmit(onSubmitLocal)}>
                <div className={`${styles.FormGroupFull}`}>
                    <FormControl fullWidth>
                        <Controller
                            control={control}
                            {...register("delivery_note", { required: 'Please enter note' })}
                            render={({ field }) => (
                                <TextField {...field} label="Delivery Note*" variant="outlined" multiline rows={4} />
                            )}
                        />
                    </FormControl>
                    {errors.delivery_note && <span className={`ErrorM`}>{errors.delivery_note.message}</span>}
                </div>

                <div className={`${styles.ButtonAction}`}>
                    <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setNoteModalOpen(false)}>Cancel</Button>
                    <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">{noteData ? 'Update' : 'Add'}</Button>
                </div>
            </form>
        </DialogContent>
    </>);
}

export default UpdateNotePopup;